export const skills_file = [
    {
        name: "HTML",
        img: "Html_logo.png",
        rating: "7.8"
    },
    {
        name: "CSS",
        img: "Css_logo.png",
        rating: "7.1"
    },
    {
        name: "PHP",
        img: "PHP_logo.png",
        rating: "7.9"
    },
    {
        name: "Javascript",
        img: "JS_logo.png",
        rating: "7.9"
    },
    {
        name: "MySQL",
        img: "MySQL_logo.png",
        rating: "7.8"
    },
    {
        name: "Vue",
        img: "Vue_logo.png",
        rating: "7.4"
    },
    {
        name: "React",
        img: "React_logo.png",
        rating: "7.7"
    },
    {
        name: "Node",
        img: "Node_logo.png",
        rating: "7.8"
    },
    {
        name: "Laravel",
        img: "Laravel_logo.png",
        rating: "6.8"
    }
]